





































import { Component, Vue } from 'vue-property-decorator';
import McpDetailsModal from '@/views/home/home-mcp-details-modal.component.vue';

@Component({
  components: {
    'mcp-details-modal': McpDetailsModal,
  },
})
export default class HomeMcpAnnouncement extends Vue {
  private visible: boolean = true;

  private showDetails: boolean = false;

  close() {
    this.visible = false;
  }

  openDetails() {
    this.showDetails = true;
  }

  closeDetails() {
    this.showDetails = false;
  }
}
